import * as XLSX from "xlsx";
import { trMoneyConvert } from "../../../../../../function/GeneralFunction";
import moment from "moment";

// Excel raporları için özel veri formatlama fonksiyonu
export const formatExcelReportData = (rawData) => {
  const businessKmPrice =
    Number(rawData.businessSettings?.businessKmPrice) || 0;

  return {
    ...rawData,
    P_MileageChargeRestSum: Number(rawData.P_MileageChargeRestSum) || 0,
    businessSettings: {
      ...rawData.businessSettings,
      businessKmPrice: businessKmPrice,
    },
    courierData: (rawData.CourierData || []).map((courier) => {
      const distance = Number(courier.SumPacketDistance) || 0;

      return {
        ...courier,
        CourierName: courier.CourierName || "Bilinmeyen Kurye",
        OrderCount: Number(courier.OrderCount) || 0,
        TotalPackageAmount: Number(courier.TotalPackageAmount) || 0,
        AvgPackageTotal: Number(courier.AvgPackageTotal) || 0,
        SumPacketDistance: distance,
        AvgPacketDistance: Number(courier.AvgPacketDistance) || 0,
        AvgPackageDelivery: Number(courier.AvgPackageDelivery) || 0,
        P_MileageChargeCourierSum:
          Number(courier.P_MileageChargeCourierSum) || 0,
      };
    }),
  };
};

const createExcelReport = (data, reportType) => {
  let excelData = [];
  let sheetName = "";
  let columns = [];

  if (reportType === "courier") {
    sheetName = "Kurye Raporu";
    columns = [
      { key: "Kurye Adı", width: 20 },
      { key: "Çalışılan Süre", width: 20 },
      { key: "Mola Süresi", width: 20 },
    ];

    excelData = data.Results.map((item) => ({
      "Kurye Adı": item.CourierName,
      "Çalışılan Süre": item.WorkingTime,
      "Mola Süresi": item.BreakTime,
    }));
  } else if (reportType === "log") {
    sheetName = "Kurye Aktivite Raporu";
    columns = [
      { key: "Başlangıç Tarihi", width: 25 },
      { key: "Bitiş Tarihi", width: 25 },
      { key: "Süre", width: 20 },
      { key: "Kurye", width: 30 },
      { key: "İşlem", width: 20 },
    ];

    const calculateDuration = (startDate, endDate) => {
      if (!startDate || !endDate) return "-";

      const start = moment(startDate);
      const end = moment(endDate);
      const duration = moment.duration(end.diff(start));

      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      return `${hours}s ${minutes}dk ${seconds}sn`;
    };

    excelData = data.Results.length
      ? data.Results.map((item) => ({
          "Başlangıç Tarihi": moment(item.StartDate).format(
            "DD.MM.YYYY HH:mm:ss"
          ),
          "Bitiş Tarihi": item.EndDate
            ? moment(item.EndDate).format("DD.MM.YYYY HH:mm:ss")
            : "-",
          Süre: calculateDuration(item.StartDate, item.EndDate),
          Kurye: item.Username || "",
          İşlem: item.Operation || "",
        }))
      : [
          {
            "Başlangıç Tarihi": "Veri bulunamadı",
            "Bitiş Tarihi": "",
            Süre: "",
            Kurye: "",
            İşlem: "",
          },
        ];
  } else if (reportType === "work") {
    sheetName = "Hesap Raporu";
    columns = [
      { key: "Kurye Adı", width: 30 },
      { key: "Paket Sayısı", width: 15 },
      { key: "Top. Paket Tutarı", width: 20 },
      { key: "Ort. Paket Tutarı", width: 20 },
      { key: "Top. Paket Mesafesi", width: 20 },
      { key: "Ort. Paket Mesafesi", width: 20 },
      { key: "Ort. Teslim Süresi", width: 20 },
      { key: "Kurye Km Hakediş", width: 20 },
      { key: "İşletme Km Maliyet", width: 20 },
    ];

    // Toplam kurye sayısını hesapla
    const totalCourierCount = data.courierData.length;
    // Toplam işletme km maliyetini al
    const totalMileageChargeRest = Number(data.P_MileageChargeRestSum) || 0;
    // Kurye başına düşen maliyeti hesapla
    const distributedMileageCharge =
      totalCourierCount > 0 ? totalMileageChargeRest / totalCourierCount : 0;

    const courierRows = data.courierData.map((item) => {
      const hakedis = Number(item.P_MileageChargeCourierSum) || 0;
      const mileageChargeRest =
        Number(item.P_MileageChargeRestSum) ||
        Number(item.MileageChargeRest) ||
        distributedMileageCharge ||
        0;

      return {
        "Kurye Adı": item.CourierName || "Bilinmeyen Kurye",
        "Paket Sayısı": (item.OrderCount || 0).toString(),
        "Top. Paket Tutarı": `${trMoneyConvert(
          item.TotalPackageAmount || 0,
          3
        )} TL`,
        "Ort. Paket Tutarı": `${trMoneyConvert(
          item.AvgPackageTotal || 0,
          3
        )} TL`,
        "Top. Paket Mesafesi": `${(item.SumPacketDistance || 0).toFixed(3)} Km`,
        "Ort. Paket Mesafesi": `${(item.AvgPacketDistance || 0).toFixed(3)} Km`,
        "Ort. Teslim Süresi": `${(item.AvgPackageDelivery || 0).toFixed(2)} Dk`,
        "Kurye Km Hakediş": `${trMoneyConvert(hakedis, 2)} TL`,
        "İşletme Km Maliyet": `${trMoneyConvert(mileageChargeRest, 2)} TL`,
      };
    });

    // Toplam satırı için değerleri hesapla
    const totals = data.courierData.reduce(
      (acc, item) => ({
        orderCount: acc.orderCount + (Number(item.OrderCount) || 0),
        totalAmount: acc.totalAmount + (Number(item.TotalPackageAmount) || 0),
        totalDistance:
          acc.totalDistance + (Number(item.SumPacketDistance) || 0),
        totalHakedis:
          acc.totalHakedis + (Number(item.P_MileageChargeCourierSum) || 0),
      }),
      { orderCount: 0, totalAmount: 0, totalDistance: 0, totalHakedis: 0 }
    );

    // Toplam satırı
    const totalRow = {
      "Kurye Adı": "Toplam",
      "Paket Sayısı": totals.orderCount.toString(),
      "Top. Paket Tutarı": `${trMoneyConvert(totals.totalAmount, 3)} TL`,
      "Ort. Paket Tutarı": "",
      "Top. Paket Mesafesi": `${totals.totalDistance.toFixed(3)} Km`,
      "Ort. Paket Mesafesi": "",
      "Ort. Teslim Süresi": "",
      "Kurye Km Hakediş": `${trMoneyConvert(totals.totalHakedis, 2)} TL`,
      "İşletme Km Maliyet": `${trMoneyConvert(totalMileageChargeRest, 2)} TL`,
    };

    excelData = [...courierRows, totalRow];
  }

  // Veri yoksa varsayılan değerler
  if (!excelData || excelData.length === 0) {
    if (reportType === "work") {
      excelData = [
        {
          "Kurye Adı": "Veri bulunamadı",
          "Paket Sayısı": "0",
          "Top. Paket Tutarı": "0,00 TL",
          "Ort. Paket Tutarı": "0,00 TL",
          "Top. Paket Mesafesi": "0,00 Km",
          "Ort. Paket Mesafesi": "0,00 Km",
          "Ort. Teslim Süresi": "0,00 Dk",
          "Kurye Km Hakediş": "0,00 TL",
          "İşletme Km Maliyet": "0,00 TL",
        },
      ];
    } else if (reportType === "log") {
      excelData = [
        {
          "Başlangıç Tarihi": "Veri bulunamadı",
          "Bitiş Tarihi": "",
          Süre: "",
          Kurye: "",
          İşlem: "",
        },
      ];
    } else {
      excelData = [
        {
          "Kurye Adı": "Veri bulunamadı",
          "Çalışılan Süre": "0s 0dk 0sn",
          "Mola Süresi": "0s 0dk 0sn",
        },
      ];
    }
  }

  const worksheet = XLSX.utils.json_to_sheet(excelData, { bookType: "xlsx" });
  worksheet["!cols"] = columns.map((col) => ({ wch: col.width }));

  const headerStyle = {
    font: { bold: true, name: "Arial" },
    fill: { fgColor: { rgb: "CCCCCC" } },
    alignment: { horizontal: "center" },
  };

  if (excelData[0]) {
    Object.keys(excelData[0]).forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      if (!worksheet[cellRef].s) worksheet[cellRef].s = {};
      worksheet[cellRef].s = headerStyle;
    });
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  workbook.Workbook = {
    Views: [{ RTL: false }],
  };

  return workbook;
};

export const createExcelTemplate = (data) => createExcelReport(data, "courier");

export const createExcelWorkTemplate = (data) =>
  createExcelReport(data, "work");

export const createLogExcelReport = (data) => createExcelReport(data, "log");
export const createCourierExcelTemplate = (data) =>
  createExcelReport(data, "courier");

export const createCompleteExcelTemplate = (data) => {
  const workbook = XLSX.utils.book_new();

  // 1. Kurye Listesi Sekmesi
  const courierSheetData = createCourierSheetData(data);
  const courierWorksheet = XLSX.utils.json_to_sheet(courierSheetData);

  // Sütun genişliklerini ayarla
  const courierCols = [
    { wch: 30 }, // Kurye Adı
    { wch: 15 }, // Paket Sayısı
    { wch: 20 }, // Top. Paket Tutarı
    { wch: 20 }, // Ort. Paket Tutarı
    { wch: 20 }, // Top. Paket Mesafesi
    { wch: 20 }, // Ort. Paket Mesafesi
    { wch: 20 }, // Ort. Teslim Süresi
    { wch: 20 }, // Kurye Km Hakediş
    { wch: 15 }, // Bonus Tutarı
    { wch: 20 }, // İşletme Km Maliyet
  ];
  courierWorksheet["!cols"] = courierCols;

  XLSX.utils.book_append_sheet(workbook, courierWorksheet, "Kurye Listesi");

  // 2. Ödeme Yöntemine Göre Toplamlar Sekmesi
  const paymentSheetData = createPaymentSheetData(data);
  const paymentWorksheet = XLSX.utils.json_to_sheet(paymentSheetData);

  const paymentCols = [
    { wch: 30 }, // Ödeme Yöntemi
    { wch: 20 }, // Tutar
  ];
  paymentWorksheet["!cols"] = paymentCols;

  XLSX.utils.book_append_sheet(workbook, paymentWorksheet, "Ödeme Toplamları");

  // 3. Adisyon Listesi Sekmesi
  if (data.orderListData && data.orderListData.Results) {
    const orderSheetData = createOrderSheetData(data.orderListData);
    const orderWorksheet = XLSX.utils.json_to_sheet(orderSheetData);

    const orderCols = [
      { wch: 20 }, // Tarih
      { wch: 15 }, // No
      { wch: 25 }, // Rest. Adı
      { wch: 25 }, // Müş. Adı
      { wch: 15 }, // Tutar
      { wch: 20 }, // Kurye
      { wch: 10 }, // Km
      { wch: 15 }, // Rest Maliyet
      { wch: 15 }, // Ekstra Tutar
      { wch: 15 }, // Kurye Hakediş
      { wch: 15 }, // Durumu
    ];
    orderWorksheet["!cols"] = orderCols;

    XLSX.utils.book_append_sheet(workbook, orderWorksheet, "Adisyon Listesi");
  }

  return workbook;
};

const createCourierSheetData = (data) => {
  const totalCourierCount = data.courierData.length;

  const totalMileageChargeRest = Number(data.P_MileageChargeRestSum) || 0;

  const distributedMileageCharge =
    totalCourierCount > 0 ? totalMileageChargeRest / totalCourierCount : 0;

  const courierRows = data.courierData.map((item) => {
    const hakedis = Number(item.P_MileageChargeCourierSum) || 0;
    const mileageChargeRest =
      Number(item.P_MileageChargeRestSum) ||
      Number(item.MileageChargeRest) ||
      distributedMileageCharge ||
      0;

    return {
      "Kurye Adı": item.CourierName || "Bilinmeyen Kurye",
      "Paket Sayısı": (item.OrderCount || 0).toString(),
      "Top. Paket Tutarı": `${trMoneyConvert(
        item.TotalPackageAmount || 0,
        3
      )} TL`,
      "Ort. Paket Tutarı": `${trMoneyConvert(item.AvgPackageTotal || 0, 3)} TL`,
      "Top. Paket Mesafesi": `${(item.SumPacketDistance || 0).toFixed(2)} Km`,
      "Ort. Paket Mesafesi": `${(item.AvgPacketDistance || 0).toFixed(2)} Km`,
      "Ort. Teslim Süresi": `${(item.AvgPackageDelivery || 0).toFixed(2)} Dk`,
      "Kurye Km Hakediş": `${trMoneyConvert(hakedis, 2)} TL`,
      "Bonus Tutarı": `${trMoneyConvert(item.BonusAmount || 0, 2)} TL`,
      "İşletme Km Maliyet": `${trMoneyConvert(mileageChargeRest, 2)} TL`,
    };
  });

  const totals = data.courierData.reduce(
    (acc, item) => ({
      orderCount: acc.orderCount + (Number(item.OrderCount) || 0),
      totalAmount: acc.totalAmount + (Number(item.TotalPackageAmount) || 0),
      totalDistance: acc.totalDistance + (Number(item.SumPacketDistance) || 0),
      totalHakedis:
        acc.totalHakedis + (Number(item.P_MileageChargeCourierSum) || 0),
      totalBonus: acc.totalBonus + (Number(item.BonusAmount) || 0),
    }),
    {
      orderCount: 0,
      totalAmount: 0,
      totalDistance: 0,
      totalHakedis: 0,
      totalBonus: 0,
    }
  );

  const totalRow = {
    "Kurye Adı": "Toplam",
    "Paket Sayısı": totals.orderCount.toString(),
    "Top. Paket Tutarı": `${trMoneyConvert(totals.totalAmount, 3)} TL`,
    "Ort. Paket Tutarı": "",
    "Top. Paket Mesafesi": `${totals.totalDistance.toFixed(2)} Km`,
    "Ort. Paket Mesafesi": "",
    "Ort. Teslim Süresi": "",
    "Kurye Km Hakediş": `${trMoneyConvert(totals.totalHakedis, 2)} TL`,
    "Bonus Tutarı": `${trMoneyConvert(totals.totalBonus, 2)} TL`,
    "İşletme Km Maliyet": `${trMoneyConvert(totalMileageChargeRest, 2)} TL`,
  };

  return [...courierRows, totalRow];
};

const createPaymentSheetData = (data) => {
  if (!data.paymentData || data.paymentData.length === 0) {
    return [
      {
        "Ödeme Yöntemi": "Veri bulunamadı",
        Tutar: "0,00 TL",
      },
    ];
  }

  return data.paymentData.map((payment) => ({
    "Ödeme Yöntemi": payment.PaymentName || "Bilinmeyen",
    Tutar: `${trMoneyConvert(payment.TotalPrice || 0, 2)} TL`,
  }));
};

const createOrderSheetData = (orderListData) => {
  if (!orderListData.Results || orderListData.Results.length === 0) {
    return [
      {
        Tarih: "Veri bulunamadı",
        No: "",
        "Rest. Adı": "",
        "Müş. Adı": "",
        Tutar: "",
        Kurye: "",
        Km: "",
        "Rest Maliyet": "",
        "Ekstra Tutar": "",
        "Kurye Hakediş": "",
        Durumu: "",
      },
    ];
  }

  return orderListData.Results.map((order) => {
    const getStatusText = (status) => {
      switch (status) {
        case 0:
          return "Beklemede";
        case 1:
          return "Kurye Atandı";
        case 2:
          return "Teslim Edildi";
        case 3:
          return "İptal Edildi";
        case 4:
          return "Kurye Kabul Edildi";
        case 5:
          return "Tamamlandı";
        default:
          return "";
      }
    };

    return {
      Tarih: moment(order.CreationTime).format("DD.MM.YYYY HH:mm:ss"),
      No: `${order.AdditionId}-${order.AdditionOrder}`,
      "Rest. Adı": order.RestName || "",
      "Müş. Adı": order.CustomerName || "",
      Tutar: `${trMoneyConvert(order.TotalPrice || 0, 2)} TL`,
      Kurye: order.CourierName || "",
      Km: `${(order.PacketDistance || 0).toFixed(2)} Km`,
      "Rest Maliyet": `${trMoneyConvert(
        order.MileageChargeRest || order.P_MileageChargeRestSum || 0,
        2
      )} TL`,
      "Ekstra Tutar": `${trMoneyConvert(order.ExtraAmount || 0, 2)} TL`,
      "Kurye Hakediş": `${trMoneyConvert(
        order.MileageChargeCourier || 0,
        2
      )} TL`,
      Durumu: getStatusText(order.OrderStatus),
    };
  });
};

export const createEndOfDayExcelTemplate = (data) => {
  const workbook = XLSX.utils.book_new();

  const allData = createSinglePageEndOfDayData(data);

  const worksheet = XLSX.utils.aoa_to_sheet(allData);

  worksheet["!cols"] = [{ wch: 45 }, { wch: 25 }, { wch: 25 }, { wch: 25 }];

  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      if (!worksheet[cellAddress]) continue;

      if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
      worksheet[cellAddress].s.alignment = {
        horizontal: "left",
        vertical: "top",
        wrapText: false,
      };

      const cellValue = worksheet[cellAddress].v;
      if (
        (typeof cellValue === "string" &&
          (cellValue.includes(",") && /\d/.test(cellValue))) ||
        cellValue.includes("%") ||
        /^\d/.test(cellValue)
      ) {
        worksheet[cellAddress].s.alignment.horizontal = "right";
      }
    }
  }

  worksheet["!ref"] = "A1:D" + allData.length;

  XLSX.utils.book_append_sheet(workbook, worksheet, "Gün Sonu Raporu");

  return workbook;
};

const createSinglePageEndOfDayData = (data) => {
  if (!data.EndOfDayReport) {
    return [["Veri bulunamadı", "", "", ""]];
  }

  const report = data.EndOfDayReport;
  const allData = [];

  // BAŞLIK
  allData.push([
    "DETAYLI RAPOR",
    `${moment(data.EndOfDayFilterData?.StartDate).format(
      "DD.MM.YYYY HH:mm"
    )} - ${moment(data.EndOfDayFilterData?.EndDate).format(
      "DD.MM.YYYY HH:mm"
    )}`,
    "",
    "JaviPos",
  ]);
  allData.push(["", "", "", ""]);

  // KASA TOPLAMLARI
  allData.push(["Kasa Toplamları", "────────────────────────────────", "", ""]);
  allData.push([
    "Gelir Toplamı",
    "",
    "",
    trMoneyConvert(report.CashReport?.TotalIncome || 0, 2),
  ]);
  allData.push([
    "Gider Toplamı",
    "",
    "",
    trMoneyConvert(report.CashReport?.TotalExpense || 0, 2),
  ]);
  allData.push([
    "Toplam Kasa",
    "",
    "",
    trMoneyConvert(report.CashReport?.TotalCash || 0, 2),
  ]);
  allData.push(["", "", "", ""]);

  // SATIŞ RAPORU
  allData.push(["Satış Raporu", "────────────────────────────────", "", ""]);
  allData.push(["", "Net Tutar", "Kdv Tutar", "Brüt Tutar"]);

  const sales = report.SalesReport || {};
  allData.push([
    "Satışlar",
    trMoneyConvert((sales.Sales || 0) - (sales.VatSales || 0), 2),
    trMoneyConvert(sales.VatSales || 0, 2),
    trMoneyConvert(sales.Sales || 0, 2),
  ]);
  allData.push(["İndirim", "", "", trMoneyConvert(sales.Discount || 0, 2)]);
  allData.push(["İkram", "", "", trMoneyConvert(sales.Offer || 0, 2)]);
  allData.push(["İade", "", "", trMoneyConvert(sales.SalesReturn || 0, 2)]);
  allData.push([
    "Ürün İptaller",
    "",
    "",
    trMoneyConvert(report.CanceledProductTotal || 0, 2),
  ]);
  allData.push([
    "Adisyon İptaller",
    "",
    "",
    trMoneyConvert(report.CanceledAdditionTotal || 0, 2),
  ]);
  allData.push([
    "Toplam Satış",
    trMoneyConvert((sales.TotalSales || 0) - (sales.VatSales || 0), 2),
    trMoneyConvert(sales.VatSales || 0, 2),
    trMoneyConvert(sales.TotalSales || 0, 2),
  ]);
  allData.push(["", "", "", ""]);

  // SATIŞ KANALI RAPORU
  allData.push([
    "Satış Kanalı Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Tipi", "Oranı", "", "Tutar"]);

  const channel = report.SalesChanelReport || {};
  const detail = channel.SalesChanelReportDetail || {};

  allData.push([
    "Masa",
    `%${(channel.ClosedTableRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(channel.ClosedTable || 0, 2),
  ]);
  allData.push([
    "Self Satış",
    `%${(channel.ClosedSelfSalesRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(channel.ClosedSelfSales || 0, 2),
  ]);

  // Ödeme yöntemleri - Self Satış için
  if (report.SalesChanelReport?.PaymentTotal) {
    const selfSalesPayments = report.SalesChanelReport.PaymentTotal.filter(
      (y) => y.OrderType == 2
    );
    if (selfSalesPayments.length > 0) {
      allData.push(["        Ödeme Tipi", "", "", "Tutar"]);
      selfSalesPayments.forEach((payment) => {
        allData.push([
          `        ${payment.PaymentName}`,
          "",
          "",
          trMoneyConvert(payment.Total || 0, 2),
        ]);
      });
    }
  }

  allData.push([
    "Paket",
    `%${(channel.ClosedPackageRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(channel.ClosedPackage || 0, 2),
  ]);
  allData.push([
    "        Telefon",
    `%${(detail.ClosedPhoneRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(detail.ClosedPhone || 0, 2),
  ]);
  allData.push([
    "        GetirYemek",
    `%${(detail.ClosedGetirYemekRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(detail.ClosedGetirYemek || 0, 2),
  ]);
  allData.push([
    "        TrendyolYemek",
    `%${(detail.ClosedTrendyolYemekRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(detail.ClosedTrendyolYemek || 0, 2),
  ]);
  allData.push([
    "        YemekSepeti",
    `%${(detail.ClosedYemekSepetiRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(detail.ClosedYemekSepeti || 0, 2),
  ]);
  allData.push([
    "        GoFody",
    `%${(detail.ClosedGoFodyRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(detail.ClosedGoFody || 0, 2),
  ]);
  allData.push([
    "        MigrosYemek",
    `%${(detail.ClosedMigrosYemekRatio || 0).toFixed(2)}`,
    "",
    trMoneyConvert(detail.ClosedMigrosYemek || 0, 2),
  ]);
  allData.push(["", "", "", ""]);

  // ÖDEME YÖNTEMLERİ
  allData.push([
    "Ödeme Yöntemleri",
    "────────────────────────────────",
    "",
    "",
  ]);
  if (report.PaymentMethodReport && report.PaymentMethodReport.length > 0) {
    report.PaymentMethodReport.forEach((payment) => {
      allData.push([
        payment.PaymentName || "Bilinmeyen",
        "",
        "",
        trMoneyConvert(payment.Total || 0, 2),
      ]);
    });
  }
  allData.push(["", "", "", ""]);

  // AÇIK HESAP RAPORU
  allData.push([
    "Açık Hesap Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Müşteri Adı", "Açık Hesap", "İndirim", "Ödeme"]);
  if (report.OpenAccount && report.OpenAccount.length > 0) {
    report.OpenAccount.filter((x) => x.CustomerType == 0).forEach(
      (customer) => {
        allData.push([
          customer.NameSurname || "Bilinmeyen",
          trMoneyConvert(customer.OpenPayment || 0, 2),
          trMoneyConvert(customer.Discount || 0, 2),
          trMoneyConvert(customer.Total || 0, 2),
        ]);
      }
    );
  }
  allData.push(["", "", "", ""]);

  // TEDARİKÇİ HESAP RAPORU
  allData.push([
    "Tedarikçi Hesap Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Müşteri Adı", "Alış Fişi", "Açık Hesap", "Ödeme"]);
  if (report.OpenAccount && report.OpenAccount.length > 0) {
    report.OpenAccount.filter((x) => x.CustomerType == 1).forEach(
      (supplier) => {
        allData.push([
          supplier.NameSurname || "Bilinmeyen",
          trMoneyConvert(supplier.Total || 0, 2),
          trMoneyConvert(supplier.OpenPayment || 0, 2),
          trMoneyConvert(supplier.Payment || 0, 2),
        ]);
      }
    );
  }
  allData.push(["", "", "", ""]);

  // PERSONEL HESAP RAPORU
  allData.push([
    "Personel Hesap Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Personel Adı", "Hakediş", "Açık Hesap", "Ödeme"]);
  if (report.OpenAccount && report.OpenAccount.length > 0) {
    report.OpenAccount.filter((x) => x.CustomerType == 4).forEach((staff) => {
      allData.push([
        staff.NameSurname || "Bilinmeyen",
        trMoneyConvert(staff.Total || 0, 2),
        trMoneyConvert(staff.OpenPayment || 0, 2),
        trMoneyConvert(staff.Payment || 0, 2),
      ]);
    });
  }
  allData.push(["", "", "", ""]);

  // KULLANICI SATIŞ RAPORU
  allData.push([
    "Kullanıcı Satış Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Kullanıcı Adı", "Adisyon", "Oranı", "Tutar"]);
  if (report.UserSalesReport && report.UserSalesReport.length > 0) {
    report.UserSalesReport.forEach((user) => {
      allData.push([
        user.Username || "Bilinmeyen",
        (user.AdditionCount || 0).toString(),
        `%${(user.TotalRatio || 0).toFixed(2)}`,
        trMoneyConvert(user.Total || 0, 2),
      ]);
    });
  }
  allData.push(["", "", "", ""]);

  // KULLANICI İADE RAPORU
  allData.push([
    "Kullanıcı İade Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Kullanıcı Adı", "Adisyon", "", "Tutar"]);
  if (report.UserSalesReturnReport && report.UserSalesReturnReport.length > 0) {
    report.UserSalesReturnReport.forEach((user) => {
      allData.push([
        user.Username || "Bilinmeyen",
        (user.AdditionCount || 0).toString(),
        "",
        trMoneyConvert(user.Total || 0, 2),
      ]);
    });
  }
  allData.push(["", "", "", ""]);

  // KURYE TESLİMAT RAPORU
  allData.push([
    "Kurye Teslimat Raporu",
    "────────────────────────────────",
    "",
    "",
  ]);
  allData.push(["Kurye", "Adisyon", "Online", "Tutar"]);
  if (report.CourierDeliveryReport && report.CourierDeliveryReport.length > 0) {
    report.CourierDeliveryReport.forEach((courier) => {
      allData.push([
        courier.Username || "Bilinmeyen",
        (courier.AdditionCount || 0).toString(),
        trMoneyConvert(courier.OnlineTotal || 0, 2),
        trMoneyConvert(courier.Total || 0, 2),
      ]);
    });

    // Toplam satırı
    const totals = report.CourierDeliveryReport.reduce(
      (acc, courier) => ({
        additionCount: acc.additionCount + (courier.AdditionCount || 0),
        onlineTotal: acc.onlineTotal + (courier.OnlineTotal || 0),
        total: acc.total + (courier.Total || 0),
      }),
      { additionCount: 0, onlineTotal: 0, total: 0 }
    );

    allData.push([
      "",
      `Toplam : ${totals.additionCount}`,
      `Toplam : ${trMoneyConvert(totals.onlineTotal, 2)}`,
      `Toplam : ${trMoneyConvert(totals.total, 2)}`,
    ]);
  }
  allData.push(["", "", "", ""]);

  // GİDER RAPORU
  allData.push(["Gider Raporu", "────────────────────────────────", "", ""]);
  allData.push(["Gider Tipi", "", "", "Tutar"]);
  if (report.Expense && report.Expense.length > 0) {
    report.Expense.forEach((expense) => {
      allData.push([
        expense.ExpenseType || "Bilinmeyen",
        "",
        "",
        trMoneyConvert(expense.Total || 0, 2),
      ]);

      // Detay giderler
      if (expense.Detail && expense.Detail.length > 0) {
        expense.Detail.forEach((detail) => {
          allData.push([
            `        ${detail.Detail || "Bilinmeyen"}`,
            "",
            "",
            trMoneyConvert(detail.Total || 0, 2),
          ]);
        });
      }
    });
  }

  return allData;
};
